<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">
        <div class="row">
          <div class="col-md-10 padding-left-0px">
            <label class="margin-bottom-0px color-Assign font-weight-bold">Edit Material ({{MaterialSpecName}})</label>
          </div>
          <div class="col-md-2 float-right">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Entry Date :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{EntryDate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">HsnCode :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{HsnCode}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Supplier :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{SupplierShortName}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Batch :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{BatchNo}}</label>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Expiry Date :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{ExpiryDate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Tax(%) :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{TaxPercent}}</label>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Batch Quantity :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{BatchQuantity}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Available Quantity :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{AvailableQuantity}}</label>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Purchase Price :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{PurchaseUnitPrice}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Selling Price :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{SellingPrice}}</label>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <div class="">
            <form class="form" novalidate="" (ngSubmit)="SaveMaterial()" #f="ngForm">

              <div class="card">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">

                          <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-4 text-align-right padding-left-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">Batch Quantity</label>
        </div>
        <div class="col-md-3 padding-right-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">[Current: {{BatchQuantity}}]</label>
        </div>
        <div class="col-md-1 padding-right-0px padding-left-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">[New]:</label>
        </div>
        <div class="col-md-4">
          <input type="text" class="form-control" placeholder="Batch Quantity"
                 id="CurrentSaveMaterialBatchInfoRequest.NewBatchQty"
                 [(ngModel)]="CurrentSaveMaterialBatchInfoRequest.NewBatchQty"
                 name="CurrentSaveMaterialBatchInfoRequest.NewBatchQty" #BtchQty="ngModel"
                 maxlength="6" pattern="[0-9]{6}" required>
          <small class="form-text text-danger"
                 *ngIf="(!BtchQty.valid && (BtchQty.dirty || BtchQty.touched) && BtchQty.errors.required )">
            (Field cannot be left blank)
          </small>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-4 text-align-right padding-left-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">Available Quantity</label>
        </div>
        <div class="col-md-3 padding-right-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">[Current: {{AvailableQuantity}}]</label>
        </div>
        <div class="col-md-1 padding-right-0px padding-left-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">[New]:</label>
        </div>
        <div class="col-md-4">
          <input type="text" class="form-control" placeholder="Available Quantity"
                 id="CurrentSaveMaterialBatchInfoRequest.NewAvailableQty"
                 [(ngModel)]="CurrentSaveMaterialBatchInfoRequest.NewAvailableQty"
                 name="CurrentSaveMaterialBatchInfoRequest.NewAvailableQty" #AvlQty="ngModel"
                 maxlength="6" pattern="[0-9]{6}" required>
          <small class="form-text text-danger"
                 *ngIf="(!BtchQty.valid && (AvlQty.dirty || AvlQty.touched) && AvlQty.errors.required )">
            (Field cannot be left blank)
          </small>

        </div>
      </div>
    </div>
  </div>-->

                          <div class="row" *canUserAccess="['HL_ER_16']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Hsn Code</label>
                                </div>

                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Hsn Code"
                                         id="UpdatedHsnCode"
                                         [(ngModel)]="UpdatedHsnCode"
                                         name="UpdatedHsnCode" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #Batchno="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Batchno.valid && (Batchno.dirty || Batchno.touched) && Batchno.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Batchno.valid && Batchno.errors.pattern)">(special characters are not allowed)</small>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row" *canUserAccess="['HL_ER_16']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Batch no</label>
                                </div>

                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Batch no"
                                         id="UpdatedBatchNo"
                                         [(ngModel)]="UpdatedBatchNo"
                                         name="UpdatedBatchNo" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #Batchno="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Batchno.valid && (Batchno.dirty || Batchno.touched) && Batchno.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Batchno.valid && Batchno.errors.pattern)">(special characters are not allowed)</small>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row" *canUserAccess="['HL_ER_16']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Exp Date</label>
                                </div>

                                <div class="col-md-5">
                                  <div class="date-form">
                                    <input class="form-control form-control-patient" placeholder="Exp Date"
                                           name="dps" [(ngModel)]="UpdatedExpiryDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}"
                                           required #d1fe="ngbDatepicker" #DOBfe="ngModel">
                                    <small class="form-text text-danger"
                                           *ngIf="(!DOBfe.valid && (DOBfe.dirty || DOBfe.touched) && DOBfe.errors.required)">(Field cannot be left blank)</small>

                                    <a (click)="d1fe.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row" *canUserAccess="['HL_ER_12']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Batch Quantity</label>
                                </div>
                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Batch Quantity"
                                         id="UpdatedBatchQuantity"
                                         [(ngModel)]="UpdatedBatchQuantity"
                                         name="UpdatedBatchQuantity" #BtchQty="ngModel"
                                         maxlength="6" pattern="[0-9]{6}" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!BtchQty.valid && (BtchQty.dirty || BtchQty.touched) && BtchQty.errors.required )">
                                    (Field cannot be left blank)
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row" *canUserAccess="['HL_ER_12']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Available Quantity</label>
                                </div>
                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Available Quantity"
                                         id="UpdatedAvailableQuantity"
                                         [(ngModel)]="UpdatedAvailableQuantity"
                                         name="UpdatedAvailableQuantity" #AvlQty="ngModel"
                                         maxlength="6" pattern="[0-9]{6}" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!AvlQty.valid && (AvlQty.dirty || AvlQty.touched) && AvlQty.errors.required )">
                                    (Field cannot be left blank)
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *canUserAccess="['HL_ER_15']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Purchase Price</label>
                                </div>
                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Purchase Price"
                                         id="UpdatedPurchaseUnitPrice"
                                         [(ngModel)]="UpdatedPurchaseUnitPrice"
                                         name="UpdatedPurchaseUnitPrice" #PurPrice="ngModel"
                                         maxlength="6" pattern="[0-9]{6}" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!PurPrice.valid && (PurPrice.dirty || PurPrice.touched) && PurPrice.errors.required )">
                                    (Field cannot be left blank)
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row" *canUserAccess="['HL_ER_15']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Selling Price</label>
                                </div>
                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Selling Price"
                                         id="UpdatedSellingPrice"
                                         [(ngModel)]="UpdatedSellingPrice"
                                         name="UpdatedSellingPrice" #SellPrice="ngModel"
                                         maxlength="6" pattern="[0-9]{6}" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!SellPrice.valid && (SellPrice.dirty || SellPrice.touched) && SellPrice.errors.required )">
                                    (Field cannot be left blank)
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *canUserAccess="['HL_ER_15']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Tax Percent</label>
                                </div>
                                <div class="col-md-5">
                                  <CodeTypeValue CodeType="TAXPC" id="UpdatedTaxPercent"
                                                 [(ngModel)]="UpdatedTaxPercent" SelectedValue=""
                                                 name="UpdatedTaxPercent">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">OK</button>                           
                  <button type="button" class="btn btn-secondary btn-raised margin-right-15px float-right button-Schedule actions-btn-prime actions-btn-prime3 font-size-13px" (click)="activeModal.close('Close click')">Cancel</button>
                </div>
              </div>
            </form>        
        </div>
      </div>
    </div>
  </div>
</div>
